import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography, Box } from '@mui/material';

const TabsComponent = ({ tabs, value, onChange }) => {
    return (
        <Tabs
            value={value}
            onChange={onChange}
            indicatorColor="transparent"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
                "& .MuiTabs-flexContainer": {
                    flexWrap: "wrap",
                },
                mb:5
            }}
        >
            {tabs.map((item, index) => (
                <Tab
                    key={index}
                    sx={{
                        minWidth: "50%" ,
                        borderBottom: value === index ? "5px solid #DC143C" : "5px solid #DC143C0D" ,
                        py: '10px'
                    }}
                    label={
                        <Typography
                            variant="body2"
                            sx={{
                                color: value === index ? '#0D0D0D' : '#555555',
                                fontWeight: 500,
                                textTransform: "capitalize",
                            }}
                        >
                            {item.label}
                        </Typography>
                    }
                />
            ))}
        </Tabs>
    );
};

TabsComponent.propTypes = {
    tabs: PropTypes.array.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default TabsComponent;
